import { TagType } from '../../../type/tag/tag.type';

export class CsvCustomerCollection {
  static readonly deficiencies: TagType[] = [
    { id: 1, label: '全て' },
    { id: 2, label: '不備あり' },
    { id: 3, label: '不備なし' },
  ]
}
